import React from "react";
import { CreateContainer } from "./ContainerCreate";
import { getSleevesByTag } from "../../api/getSleeves";
import Skeleton from "react-loading-skeleton";

class SleevesByTagContainer extends React.Component {
  componentDidMount() {
    const page = this.props.page || 1;
    const find = this.props.find || "";
    this.props.request(find, page);
  }
  componentWillReceiveProps(nextProps) {
    const { page: nextPage, find: nextFind } = nextProps;
    const { page, find } = this.props;
    if (nextPage !== page || nextFind !== find) {
      this.props.request(nextFind, nextPage);
    }
  }
  render = () => {
    const { data, loading, failure, render } = this.props;
    const result = (data && data.data) || [];
    if (loading) {
      return <Skeleton count={3} />;
    }
    return render({ result, loading, failure });
  };
}

export default CreateContainer(getSleevesByTag, SleevesByTagContainer);
